import {CheatInfoController} from './CheatInfoController';
import {CheatInfoView} from './CheatInfoView';
import {CheatPlugin} from '../../CheatModuleInterfaces';

const info: CheatPlugin = {
    name: 'Info Cheat',
    init: () => [
        CheatInfoController,
        CheatInfoView
    ]
};

export default info;
